{
  "becameKindCurator_one": "became curator of every item of {{count}} kind",
  "becameKindCurator_other": "became curator of every item of {{count}} kinds",
  "by": "by {{name}}",
  "changes": {
    "curation_granted": "became curator of {{scope}}",
    "curation_revoked": "stopped being curator of {{scope}}",
    "group_changed": "The group {{group}} was renamed or moved",
    "group_curation_changed": "The group {{group}} now curates {{kinds}}",
    "group_excluded": "The installation group {{group}} is no longer included",
    "group_grants_changed": "What the group {{group}} allows changed",
    "group_included": "The installation group {{group}} was included",
    "group_made": "The group {{group}} was made",
    "group_member_added": "joined the group {{group}}",
    "group_member_removed": "left the group {{group}}",
    "group_order_changed": "The order of the groups changed",
    "group_overrides_changed": "What the group {{group}} gives here changed",
    "group_removed": "The group {{group}} was removed",
    "group_role_changed": "The group {{group}} now has the role {{role}}",
    "group_role_granted": "The group {{group}} was given the role {{role}}",
    "group_role_revoked": "The group {{group}} no longer has a role here",
    "membership_granted": "joined as {{role}}",
    "membership_revoked": "left the project",
    "project_deleted": "The project was deleted",
    "project_purged": "The project was purged",
    "project_restored": "The project was restored",
    "project_role_changed": "became {{role}}",
    "project_settings_changed": "changed the project's rules"
  },
  "empty": "No permission has changed yet.",
  "everyItemOf": "every item of the kind {{kind}}",
  "groupCurationTaken": "The group {{group}} no longer curates anything here",
  "oneItemOf": "one item of the kind {{kind}}",
  "reason": "Reason: {{reason}}",
  "reconstructed": "from records older than the history",
  "removedAccount": "A removed account",
  "roles": {
    "contributor": "contributor",
    "project_administrator": "project administrator",
    "reader": "reader"
  },
  "rulesChanged": "The project's rules changed: {{rules}}",
  "rulesFromDefaults": "The project's rules were set from the installation's defaults",
  "title": "Permission history"
}
